import { ScreeningQuestionOption } from "@/services/DTOs/ScreeningQuestionOption";

export interface IScreeningQuestion {
  id?: string;
  format: string;
  title: string;
  locale: string;
  type: string;
  path?: string;
  purpose: string;
  answerLimit?: number;
  options: ScreeningQuestionOption[];
  rank: number;
  temporaryId?: string;
  hasPendingContent?: boolean;
  active: boolean;
}

export class ScreeningQuestion {
  public id?: string;
  public format: string;
  public title: string;
  public locale: string;
  public type: string;
  public path?: string;
  public purpose: string;
  public answerLimit?: number;
  public options: ScreeningQuestionOption[];
  public rank: number;
  public temporaryId?: string;
  public hasPendingContent?: boolean;
  public active: boolean;

  constructor(data: IScreeningQuestion) {
    this.id = data.id;
    this.format = data.format;
    this.title = data.title;
    this.locale = data.locale;
    this.type = data.type;
    this.path = data.path;
    this.purpose = data.purpose;
    this.answerLimit = data.answerLimit;
    this.options = data.options;
    this.rank =  data.rank;
    this.temporaryId = data.temporaryId;
    this.hasPendingContent = data.hasPendingContent;
    this.active = data.active;
  }
}
